import { render, staticRenderFns } from "./adddorm-form.vue?vue&type=template&id=284372bd&scoped=true"
import script from "./adddorm-form.vue?vue&type=script&lang=js"
export * from "./adddorm-form.vue?vue&type=script&lang=js"
import style0 from "./adddorm-form.vue?vue&type=style&index=0&id=284372bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284372bd",
  null
  
)

export default component.exports